const namespace = "user";

export const user = `${namespace}_list`;
export const roles = `${namespace}_roles`;
